import { Menu, Transition } from "@headlessui/react";
import useNotification from "@/hooks/useNotification";
import { Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import { NotificationType } from "@/api/notification";

const NotificationMenu = () => {
    const {
        notifications,
        markAsRead,
        clearAll,
        isLoading,
    } = useNotification();
    const navigate = useNavigate();

    const handleClearAll = () => {
        clearAll();
    };

    const handleNotificationClick = async (notification: NotificationType) => {
        try {
            await markAsRead(notification.id);
            if (notification.data.type !== 'inventory.assigned' && notification.data.url) {
                navigate(notification.data.url);
            }
        } catch (error) {
            console.error('Error handling notification click:', error);
        }
    };
    return (
        <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
        >
            <Menu.Items className="origin-top-right absolute right-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                    <div className="px-4 py-2 border-b border-gray-200 flex justify-between items-center">
                        <h3 className="text-sm font-medium text-gray-900">
                            Notifications
                        </h3>
                        <button
                            onClick={handleClearAll}
                            disabled={isLoading || !notifications?.length}
                            className="text-xs text-blue-600 hover:text-blue-800 disabled:opacity-50"
                        >
                            Clear All
                        </button>
                    </div>
                    <div className="max-h-96 overflow-y-auto">
                        {notifications?.length > 0 ? (
                            notifications.map(
                                (notification: NotificationType) => (
                                    <Menu.Item key={notification.id}>
                                        {({ active }) => (
                                            <div
                                                className={`${active ? "bg-gray-100" : ""
                                                    } px-4 py-2 cursor-pointer`}
                                                onClick={() =>
                                                    handleNotificationClick(notification)
                                                }
                                            >
                                                <p className="text-sm font-medium text-gray-900">
                                                    {notification.data.message}
                                                </p>
                                                <p className="text-xs text-gray-500">
                                                    {notification.data.subject}
                                                </p>
                                                <p className="text-xs text-gray-400 mt-1">
                                                    {new Date(
                                                        notification.created_at
                                                    ).toLocaleString()}
                                                </p>
                                            </div>
                                        )}
                                    </Menu.Item>
                                )
                            )
                        ) : (
                            <Menu.Item>
                                <div className="px-4 py-2 text-sm text-gray-500">
                                    No new notifications
                                </div>
                            </Menu.Item>
                        )}
                    </div>
                </div>
            </Menu.Items>

        </Transition>
    )
}

export default NotificationMenu;
